import { render, staticRenderFns } from "./SingleStockHolder.vue?vue&type=template&id=dfb6d31c&scoped=true"
import script from "./SingleStockHolder.vue?vue&type=script&lang=js"
export * from "./SingleStockHolder.vue?vue&type=script&lang=js"
import style0 from "./SingleStockHolder.vue?vue&type=style&index=0&id=dfb6d31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb6d31c",
  null
  
)

export default component.exports